export default "__VITE_ASSET__af132fdd__"